import React, { Component } from 'react';

class WhyChooseUs extends Component {
  render() {
    return (
      <section className='section why-choose-us'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-lg-6 mb-4 mb-lg-0'>
              <div className='pr-0 pr-lg-2'>
                <h2 className='section-heading h1 text-dark'>Why Choose Us</h2>
                <p className='mt-30'>
                  At Cell Station, highly trained technicians provide fast and affordable repairs for all your devices.
                  We offer free estimates and highly competitive pricing. If you are looking for tablet, cell phone, or
                  computer repair in the Willow Grove, contact Cell Station for more information today.
                </p>
                <p className='mt-20'>
                  1. Expert technicians with years of experience. <br />
                  2. Fast, reliable, and affordable repairs. <br />
                  3. High-quality parts and service guaranteed. <br />
                  4. Convenient, same-day repair options. <br />
                  5. Customer satisfaction is our top priority.
                  <br />
                  6. We fix all phone models and issues.
                  <br />
                </p>
                <div className='row text-center'>
                  <div className='col-md-5 col-sm-6 mt-30'>
                    <img src={process.env.PUBLIC_URL + '/assets/images/why-choose-us/01.png'} alt='' loading="lazy" />
                    <h4 className='text-dark mt-15'>After Sales Support</h4>
                  </div>
                  <div className='col-md-5 col-sm-6 mt-30'>
                    <img src={process.env.PUBLIC_URL + '/assets/images/why-choose-us/02.png'} alt='' loading="lazy" />
                    <h4 className='text-dark mt-15'>Client Satisfaction</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-lg-6 mt-4 mt-lg-0'>
              <div className='row masonry'>
                <div className='col-sm-6'>
                  <div className='block text-center'>
                    <div className='icon'>
                      <img src={process.env.PUBLIC_URL + '/assets/images/why-choose-us/03.png'} alt='' loading="lazy" />
                    </div>
                    <h4 className='mt-25 text-dark'>Skill</h4>
                    <p className='mt-20'>
                      Our skilled technicians provide fast, reliable cellphone repairs, ensuring top-quality service and
                      customer satisfaction.
                    </p>
                  </div>
                  {/* why choose us item */}
                </div>
                <div className='col-sm-6'>
                  <div className='block text-center mt-30'>
                    <div className='icon'>
                      <img src={process.env.PUBLIC_URL + '/assets/images/why-choose-us/04.png'} alt='' loading="lazy" />
                    </div>
                    <h4 className='mt-25 text-dark'>Experience</h4>
                    <p className='mt-20'>
                      With years of experience, we provide expert iPhone repairs, ensuring quality and customer
                      satisfaction.
                    </p>
                  </div>
                  {/* why choose us item */}
                </div>
                <div className='col-sm-6'>
                  <div className='block text-center mt-30'>
                    <div className='icon'>
                      <img src={process.env.PUBLIC_URL + '/assets/images/why-choose-us/05.png'} alt='' loading="lazy" />
                    </div>
                    <h4 className='mt-25 text-dark'>Quality</h4>
                    <p className='mt-20'>
                      Absolutely, we’ll assess your tech for free. If additional work is required, we’ll take care of
                      it.
                    </p>
                  </div>
                  {/* why choose us item */}
                </div>
                <div className='col-sm-6'>
                  <div className='block text-center mt-30'>
                    <div className='icon'>
                      <img src={process.env.PUBLIC_URL + '/assets/images/why-choose-us/06.png'} alt='' loading="lazy" />
                    </div>
                    <h4 className='mt-25 text-dark'>Guarantees</h4>
                    <p className='mt-20'>
                      We guarantee fast, reliable cellphone repair with high-quality service and customer satisfaction
                      every time
                    </p>
                  </div>
                  {/* why choose us item */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default WhyChooseUs;
